export default __webpack_public_path__ + "static/media/calendar_icon.a67581ca.svg";